import $ from 'jquery'
$(function () {
	const itemBuilder = {
		'map-photos': item =>
			`<div class="gallery-item" data-modal-trigger="photo"><img data-country="${
				item.country || ''
			}"  src="${item.image}" alt="${item.title}" data-src="${item.image_large}" />
                            <div class="hover-area">
                                <h3>${item.title || ''}</h3>
                                <p>${item.country || ''}</p>
                            </div>
                            </div>`,
		spotlight: function (item) {
			const { image } = item //editor autosave bug;
			return `<div class="story-item">
                                <a href="${item.redirect || item.link}"
                                    target="${item.redirect ? '_blank' : ''}">
                                    <div class="image-area"
                                        style="background-image:url('${image}')"></div>
                                    <div class="content-area">
                                        <div class="match-height-1">
                                            <h4>${item.title}</h4>
                                            <div>${item.area}</div>
                                            <div class="icons">
                                                ${item.icon_html}
                                            </div>
                                        </div>
                                        <div class="rm">Read More <i class="fa fa-angle-right"></i></div>
                                    </div>
                                </a>
                            </div>`
		},
		'map-resources': function (item, arg = {}) {
			const { image } = item //editor autosave bug;
			return `<div class="story-item" style="background-color:${arg.colour}">
							<div class="image-area" style="background-image:url('${image}')"></div>
							<div class="content-area">
								<h3>${item.title}</h3>
								${item.link_html}
							</div>
						</div>`
		}
	}
	const $window = $(window)
	$('[data-role="ajax-module"]').each(function () {
		const $module = $(this)
		const postType = $(this).attr('data-post-type')
		const cat = $(this).attr('data-cat')
		const $posts = $(this).find('[data-role="posts"]')
		const $loadmore = $(this).find('[data-role="load-more"]')
		let _paged = 1
		if (
			$window.scrollTop() > $posts.offset().top - $window.height() &&
			!$posts.hasClass('initialised')
		) {
			fetchPosts()
			$posts.addClass('initialised')
		}

		$window.on('scroll', function () {
			if (
				$window.scrollTop() > $posts.offset().top - $window.height() &&
				!$posts.hasClass('initialised')
			) {
				fetchPosts()
				$posts.addClass('initialised')
			}
		})

		$loadmore.on('click', function (e) {
			e.preventDefault()
			fetchPosts(_paged)
		})

		function fetchPosts(paged = 1) {
			if ($posts.hasClass('loading')) {
				return
			}
			$posts.addClass('loading')
			$.get(wp_data.home_url + '/wp-admin/admin-ajax.php', {
				action: 'fw_get_posts',
				postType,
				cat,
				paged
			}).then(response => {
				const raw = JSON.parse(response)
				const { data, next } = raw
				let html = ''
				if (_paged == 1 && data.length == 0) {
					$module.hide()
				}
				if (data && data.length > 0) {
					data.forEach(function (item) {
						html += itemBuilder[postType](item, {
							colour: $module.attr('data-box-colour')
						})
					})
				}
				if (!next) {
					$loadmore.hide()
				} else {
					_paged = paged + 1
				}
				$posts.append(html)
				$posts.removeClass('loading')
			})
		}
	})

	//Gallery modal
	const photoModalSource = $('[data-remodal-id=photo-modal]')
	const photoModal = photoModalSource.remodal()
	const photoContainer = photoModalSource.find('.photo-container')
	let currentSrc = ''
	let currentCap = ''
	$(document).on('click', '[data-modal-trigger="photo"]', function (e) {
		e.preventDefault()
		const $img = $(this).find('>img')
		const dataSrc = $img.attr('data-src')
		if (dataSrc) {
			currentSrc = dataSrc
			const country = $img.attr('data-country')
			currentCap =
				$img.attr('alt') + '<div class="country">' + country || '' + '</div>'
			photoModal.open()
		}
	})

	//What happens when the photo is openning
	$(document).on('opening', '.photo-modal', function () {
		//re-apply the iframe src attribute
		photoContainer.html(
			`<img src="${currentSrc}" alt="" /><div class="caption">${currentCap}</div>`
		)
	})

	$(document).on('closed', '.photo-modal', function () {
		photoContainer.html('')
	})
})
